export const MISSING_FIELD_ID = 'MISSING_FIELD_ID';

export const SEVERITY = {
  WARN: 'warn',
  ERROR: 'error',
};
